import React, { useState, useEffect, useCallback } from "react";
import { TemplateDataTable } from "./TemplateDataTable";
import { NODE_HOST_URL_v1 } from "../api/Api";
import styles from "./TemplateReport.module.css";
import Axios from "../../../axios/Axios";


const TemplateReport = ({
    selectedTemplates,
    onSelectionChange,
    onCompare,
    onClear,
}) => {
    const STATUS_MAP = {
        0: "pending",
        1: "approved",
        2: "rejected",
    };
    const [filters, setFilters] = useState({
        templateName: "",
        category: 0,
        templateType: 0,
        dynamicContent: 0,
    });

    const columns = [
        {
            key: "temp_name",
            label: "Template Name",
            sortable: true,
            filterable: true,
            backendFilterKey: "Tname",
            render: (row) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{row.temp_name}</div>
                    <div style={{ fontSize: 11, color: "#64748B" }}>
                        Updated: {row.update_datetime?.split("T")[0]}
                    </div>
                </div>
            ),
        },
        {
            key: "channel",
            label: "Channel",
            sortable: true,
            filterable: false,
            render: () => (
                <span
                    style={{
                        padding: "4px 10px",
                        borderRadius: 999,
                        fontSize: 11,
                        fontWeight: 600,
                        background: "#DCFCE7",
                        color: "#31d16e",
                    }}
                >
                    WHATSAPP
                </span>
            ),
        },
        {
            key: "temp_category",
            label: "Category",
            sortable: true,
            filterable: true,
            backendFilterKey: "Category",
        },
        {
            key: "dynamic_content",
            label: "Dynamic Content",
            sortable: true,
            filterable: true,
            backendFilterKey: "DynaCon",
        },
        {
            key: "temp_type",
            label: "Template Type",
            sortable: true,
            filterable: true,
            backendFilterKey: "TemType",
            render: (row) => (
                <div style={{ fontWeight: 500 }}>{row.temp_type}</div>
            ),
        },
        {
            key: "temp_status",
            label: "Status",
            sortable: true,
            filterable: false,
            render: (row) => {
                const status = STATUS_MAP[row.temp_status] || "pending";

                return (
                    <span
                        style={{
                            padding: "6px 12px",
                            borderRadius: 999,
                            fontSize: 11,
                            fontWeight: 600,
                            background:
                                status === "approved"
                                    ? "#DCFCE7"
                                    : status === "pending"
                                        ? "#FEF3C7"
                                        : "#FEE2E2",
                            color:
                                status === "approved"
                                    ? "#227b44"
                                    : status === "pending"
                                        ? "#92400E"
                                        : "#991B1B",
                        }}
                    >
                        {status.charAt(0).toUpperCase() + status.slice(1)}
                    </span>
                );
            },
        },
        {
            key: "action",
            label: "Action",
            filterable: false,
            render: () => (
                <button
                    style={{
                        border: "none",
                        background: "transparent",
                        color: "#6366F1",
                        fontWeight: 500,
                        cursor: "pointer",
                    }}
                >
                    Edit
                </button>
            ),
        },
    ];

    const PAGE_SIZE = 5;

    const fetchTemplateReport = useCallback(async ({ page, search, activeFilters }) => {
        const lStorage = JSON.parse(localStorage.getItem("login"));
        const userId = lStorage?.user?.userId;
        const token = lStorage?.token;

        const response = await Axios.post(
            `${NODE_HOST_URL_v1}/whatsapp`,
            {
                method: "TemplateList",
                filter: {
                    wid: 0,
                    Tname: activeFilters?.templateName || 0,
                    Category: activeFilters?.category ?? 0,
                    TemType: activeFilters?.templateType ?? 0,
                    DynaCon: activeFilters?.dynamicContent ?? 0,
                },
                user_id: userId,
            },
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );

        let allData = response.data?.data || [];
        allData.sort(
            (a, b) => new Date(b.created) - new Date(a.created)
        );

        if (search) {
            const s = search.toLowerCase();

            const statusMap = {
                0: "pending",
                1: "approved",
                2: "rejected",
            };

            allData = allData.filter((item) =>
                item.temp_name?.toLowerCase().includes(s) ||
                item.temp_category?.toLowerCase().includes(s) ||
                item.temp_type?.toLowerCase().includes(s) ||
                String(item.dynamic_content)?.includes(s) ||
                statusMap[item.temp_status]?.includes(s)
            );
        }

        const start = (page - 1) * PAGE_SIZE;
        const end = start + PAGE_SIZE;

        return {
            data: allData.slice(start, end),
            total: allData.length,
        };
    }, []);  // IMPORTANT
    return (
        <div className="card border-0 shadow-sm mt-4">

            <TemplateDataTable
                columns={columns}
                fetchData={fetchTemplateReport}
                pageSize={5}
                filters={filters}
                flags={{
                    search: true,
                    sorting: true,
                    pagination: true,
                    skeleton: true,
                    selectable: true,
                }}
                selectedRows={selectedTemplates}
                onSelectionChange={onSelectionChange}
            />

            {selectedTemplates.length > 0 && (
                <div className={styles.compareBar}>
                    <div className={styles.selectionInfo}>
                        <span className={styles.selectionCount}>
                            {selectedTemplates.length}
                        </span>
                        <span className={styles.selectionText}>Selected</span>
                    </div>

                    <button className={styles.clearBtn} onClick={onClear}>
                        Clear
                    </button>

                    <button
                        className={styles.compareBtn}
                        onClick={onCompare}
                        disabled={selectedTemplates.length < 2}
                    >
                        Compare →
                    </button>
                </div>
            )}
        </div>
    );
};

export default TemplateReport;
